import React, { Component } from 'react';
let DateTimeField = require('react-bootstrap-datetimepicker');
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

class DatePickerExpiration extends Component {
    constructor(props) {
        super(props);
        this.changeDate = this.changeDate.bind(this);
        //this.changeDataError = this.changeDataError.bind(this);
    }

    changeDate(date) {
        if (date != "Invalid date") {
            //let resultado = GlobalHelper.CompararFechaDeHoy(date);
            //if (resultado.estado) {
            this.props.changeDate("RENOVACION", date);
            //} else {
            //    this.props.changeDataError();
            //}
        }
        else {
            this.props.changeDataError();
        }
    }

    render() {
        let fechaExpiracion;
        let defaultText;

        if (this.props.data.DateExpiration != null && this.props.data.DateExpiration != "") {
            fechaExpiracion = defaultText = GlobalHelper.FormatDate(this.props.data.DateExpiration);
        } else {
            defaultText = "Seleccione una fecha";
            fechaExpiracion = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
        }

        return (
            <div className="row top-separator-xs">
                <div className="col-md-3 vertical-align">
                    <label className="label-primary">Aplica nuevo precio a partir de</label>
                </div>
                <div className="col-md-3 vertical-align">
                    <DateTimeField
                        mode="date"
                        defaultText={defaultText}
                        dateTime={fechaExpiracion}
                        format={"DD/MM/YYYY"}
                        inputFormat={"DD/MM/YYYY"}
                        onChange={this.changeDate}
                    />
                </div>
            </div>
        );
    }
};

export default DatePickerExpiration;
